/*
Sohel 01/10/2023 2699299906 Implemented Copy Functionality
Sohel 01/02/2023 2698964415 fixed code uppercase issue
Sohel 01/02/2023 2698964415 fixed code validation issue
//suresh peddavoora 02/24/2023 2698964415 New UI changes
Rohini 03/02/2023 2698964415 commented input props
sohel 03/06/2023 2698964415 Added validation message for existing value
Akhila 06/06/2023 2698964415 added code and description in action
Akhila 06/08/2023 2692790263 title label placeholder name change
Ravi 06/23/2023 2698964415 fixed submit issue
*/
import React, {useContext, useEffect, useRef} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from './../../../../../components/PageLoader/index';
import BreadCrums from '../../../../../util/BreadCrum';
import {
  fetchAllRecordGroupCode,
  postRecordGroupCopy,
} from '../../../../../redux/reducers/DataManagerRecordGroup';
import {currsorCodeIssue} from '../../../../../components/UpperCaseCode';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
const CopyRecordGroup = ({ oldGroupCodeData, type }) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {isLoading, allRecordGroupCode} = useSelector(
    ({dataManagerRecordGroup}) => dataManagerRecordGroup,
  );
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialValues = {
    code: '',
    description: '',
  };
  const codeRef = useRef();
  const typeModule = type === 'Export' ? 'Export' : 'Import';
  const checkCodeExist = (value) => {
    if (allRecordGroupCode && allRecordGroupCode?.length > 0 && value) {
      const ar = [];
      allRecordGroupCode.filter((i) => {
        if (
          i?.groupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkRecordCodeAlreadyExist = (value) => {
    if (allRecordGroupCode && allRecordGroupCode?.length > 0 && value) {
      const ar = [];
      allRecordGroupCode.filter((i) => {
        if (
          i?.groupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const schema = Yup.object().shape({
    code:  Yup.string()
      .required(`${typeModule} Record Group Name is required`)
      .max(25, `${typeModule} Record Group Name cannot exceed 25 characters`)
      .test(
        'code',
              `${typeModule} Record Group Name already exist`,
              (value) => !checkCodeExist(value),
      )
      .test(
        'code',
              `${typeModule} Record Group Name has already been used in the past`,
              (value) => !checkRecordCodeAlreadyExist(value),
      ),
    description: Yup.string()
      .test('description', `${typeModule} Record Group Description is required`, (value) => {
        return value?.replaceAll(' ', '');
      })
      .required(`${typeModule} Record Group Description is required`)
      .max(100, `${typeModule} Record Group Description cannot exceed 100 characters`),
  });
  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        recordGroupCode: values?.code ? values?.code : '',
        oldRecordGroupCode: oldGroupCodeData?.groupCode ? oldGroupCodeData?.groupCode : '',
        groupDescription: values?.description ? values?.description : '',
        tabType: type,
        oldRecordGroupId : oldGroupCodeData?.dmRecordGroupId ? oldGroupCodeData?.dmRecordGroupId : 0,
      };
      dispatch(postRecordGroupCopy(data));
    }
  };
  useEffect(() => {
    dispatch(fetchAllRecordGroupCode(type));
  }, []);

  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                touched,
                errors,
                resetForm,
                handleBlur,
                setFieldValue,
              } = props;
              return (
                <div>
                  <BreadCrums
                    // name={"Record Group Name"}
                    name={`${typeModule} Record Group Name`}
                    code={oldGroupCodeData?.groupCode}
                    // description={"Record Group Description"}
                    description={`${typeModule} Record Group Description`}
                    descriptionValue={oldGroupCodeData?.groupDescription}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder={`Enter ${typeModule} Record Group Name`}
                              margin="dense"
                              name="code"
                              variant="outlined"
                              value={values?.code}
                              label={`${typeModule} Record Group Name`}
                              inputRef={codeRef}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              required
                              onBlur={handleBlur}
                              onChange={(e) => {
                                const value = currsorCodeIssue(codeRef);
                                setFieldValue('code', value);
                              }}
                              touched={touched.code}
                              error={Boolean(errors.code && touched.code)}
                              fullWidth
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched.code && errors.code}
                            </FormHelperText>
                          </Grid>

                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder={`Enter ${typeModule} Record Group Description`}
                              margin="dense"
                              name="description"
                              value={values.description}
                              variant="outlined"
                              label={`${typeModule} Record Group Description`} // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setFieldValue('description', e.target.value);
                              }}
                              touched={touched.description}
                              required
                              error={Boolean(errors.description && touched.description)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.description && errors.description}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="button-spacing-mb new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        disabled = {enabledSubmission}
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {isLoading && <PageLoader />}
    </>
  );
};

export default CopyRecordGroup;
